<template>
	<b-modal
		ref="logsTableModal"
		id="logs-tables-dialog"
		:modal-class="theme"
		hide-footer
		centered
		body-class="modal__confirm"
		size="xl"
	>
		<LogsTable :logsA="logs" :logsFilterTable="logsFilter" />
		<ErrorDialog ref="errDialog" />
	</b-modal>
</template>

<script>
import LogsTable from './LogsTable';
import ThemeService from '../../services/theme';
import ConsolidatedLogsService from '../../services/consolidated-logs';
import ErrorDialog from '../shared/ErrorDialog';

export default {
	name: "LogsTableDialog",
	components: {
		LogsTable,
		ErrorDialog
	},
	data() {
		return {
			logs: [],
			title: "",
			logsFilter: {},
			loading: false,
			startedAt: null
		};
	},
	created() {
		this.theme = ThemeService.instance().getTheme() || 'light';
		this.listenForThemeChanges();
	},
	methods: {
		show() {
			this.timer = setInterval(() => {
				if (!this.loading) {
					this.getConsolidatedLogs();
				}
			}, 10000)
			this.getConsolidatedLogs();
			this.$refs.logsTableModal.show();
		},
		getConsolidatedLogs(){
			ConsolidatedLogsService.instance().getConsolidatedLogs(this.logsFilter)
			.then(response => {
				var data = response.data;
				if(!this.logsFilter.startAt){
					this.logsFilter.startAt = data.now;
				}
				this.logs = data.logs;	
				this.loading = false;
				
			}).catch((error) => {
				this.$refs.errDialog.show(error);
			});
		},
		listenForThemeChanges: function () {
			ThemeService.instance().events.on("themechanged", () => {
				this.theme = ThemeService.instance().getTheme();
			});
		},
		
	}
};
</script>
